import { useState, useRef, useEffect } from 'react';

const BASE = process.env.REACT_APP_BACKEND_URL;

const REELS = [
  { id: 1, src: `${BASE}/api/static/reels/reel_1.mp4` },
  { id: 2, src: `${BASE}/api/static/reels/reel_2.mp4` },
  { id: 3, src: `${BASE}/api/static/reels/reel_3.mp4` },
  { id: 4, src: `${BASE}/api/static/reels/reel_4.mp4` },
  { id: 5, src: `${BASE}/api/static/reels/reel_5.mp4` },
];

export default function ReelShowcase() {
  const [current, setCurrent] = useState(0);
  const videoRef = useRef(null);

  // Autoplay whenever reel changes
  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    v.load();
    v.play().catch(() => {});
  }, [current]);

  function go(idx) { setCurrent(idx); }
  function prev() { go(current === 0 ? REELS.length - 1 : current - 1); }
  function next() { go(current === REELS.length - 1 ? 0 : current + 1); }

  return (
    <div className="reel-showcase" data-testid="reel-showcase">
      <p className="sec-overline" style={{ marginBottom: '1.5rem' }}>Featured Reels</p>

      <div className="reel-phone">
        <div className="reel-notch" />

        <div className="reel-screen">
          <video
            ref={videoRef}
            key={REELS[current].src}
            className="reel-video"
            src={REELS[current].src}
            autoPlay
            muted
            loop
            playsInline
            disablePictureInPicture
            controlsList="nodownload nofullscreen noremoteplayback"
          />

          {/* Dot indicators */}
          <div className="reel-dots">
            {REELS.map((_, i) => (
              <button
                key={i}
                className={`reel-dot${i === current ? ' active' : ''}`}
                onClick={() => go(i)}
                aria-label={`Reel ${i + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Arrows */}
        <button className="reel-arrow reel-arrow-prev" onClick={prev} aria-label="Previous reel">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M9 1L3 7l6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <button className="reel-arrow reel-arrow-next" onClick={next} aria-label="Next reel">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M5 1l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>

      <p className="reel-counter">{current + 1} / {REELS.length}</p>
    </div>
  );
}
